import React from 'react'

const InvoiceStepperComponent = (props) => {
    let { headingName, greenTickNumber = 3, isClaim = false } = props;
    return (
        <>
            <div className='contentHead_new'>
                <h4> Create Bill Raise </h4>

                <div className='_stepedBxs'>
                    <div className={greenTickNumber >= 1 ? '_seperateCheckes activated' : '_seperateCheckes'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.4999" cy="10.5" r="10.5" fill="#20A154" />
                            <path d="M5.99988 10.1672L9.16704 13.3343L15.4999 7" stroke="white" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Bill Details</span>
                    </div>

                    <div className={greenTickNumber >= 2 ? '_seperateCheckes activated' : '_seperateCheckes'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Select {isClaim ? 'Claims' : 'LR'}</span>
                    </div>

                    <div className={greenTickNumber >= 3 ? '_seperateCheckes activated' : '_seperateCheckes'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Selected {isClaim ? 'Claims' : 'LR'}</span>
                    </div>

                    <div className={greenTickNumber >= 4 ? '_seperateCheckes activated' : '_seperateCheckes'}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <circle cx="10.5" cy="10.5" r="10.5" fill="#D9D9D9" />
                            <path d="M6 10.1672L9.16716 13.3343L15.5 7" stroke="#828282" strokeWidth="1.49289" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                        <span>Summary</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InvoiceStepperComponent